<template>
  <div class="list__container">
    <div class="reviews__content">
      <div class="review">
        <div class="review__stars">
          <img v-for="star in 5" :key="star" :src="mediaBaseUrl + 'subscription/reviews/star.svg'" alt="star">
        </div>

        <div class="review__content">
          <p>
            {{activeReview.text}}
          </p>
        </div>

        <div class="review__author">
          <div class="author__content">
            <div class="author__name">{{activeReview.author}}</div>
            <div class="review__date">{{activeReview.date}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="controllers">
      <div class="img" @click="prevSlide">
        <img :src="mediaBaseUrl + 'subscription/reviews/arrow-left.svg'" alt="arrow left">
      </div>

      <div class="img" @click="nextSlide">
        <img :src="mediaBaseUrl + 'subscription/reviews/arrow-right.svg'" alt="arrow right">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewsList",

  inject: ["mediaBaseUrl"],

  props: {
    reviews: {
      default: () => [
        {
          author: "Joshua Perez",
          date: "July 18, 2024",
          text: "Really well done app. Easy to navigate and use! It's been so nice to keep track of my heart rate, and fun to experiment with checking my heart rate at different times. Before and after morning coffee. After drinking, etc. It's been great to know this info about my heart.",
        },
        {
          author: "Nicholas Taylor",
          date: "January 5, 2024",
          text: "Love it. I suffer with high heart rates and this works well at telling me what my heart rate is. Ive tested this a few times next to the machine's in hospital and the readings are almost exactly the same. Only app I've ever left a review for. I just make sure I check it twice to be more accurate with the readings and make sure they are consistent.",
        },
        {
          author: "Lauren Garcia",
          date: "May 28, 2024",
          text: "After many random tests upon downloading, this is extremely accurate. After reading the reviews and wondering how on earth a camera could measure a heartbeat, I was more than skeptical, but this monitor is the best I've used. I recently had a blood pressure scare and landed myself in the hospital, so constantly worrying about my heart rate has only added an anxiety that adds to blood pressure.",
        },
      ],
    }
  },

  data() {
    return {
      slidesToShow: 1,
      activeSlide: 0,
      sliderWidth: 343,
      sliderGap: 24,
    };
  },

  created() {
    // this.timer = setInterval(() => this.nextSlide(), 10000);
    window.addEventListener("resize", this.isMobile);
    this.isMobile();
  },

  beforeDestroy() {
    // clearInterval(this.timer);
    window.removeEventListener("resize", this.isMobile);
  },

  computed: {
    sliderLeft() {
      const slide = document.getElementsByClassName("review")[0];
      let slideWidth = this.sliderWidth;

      if (slide) {
        slideWidth = +getComputedStyle(slide).width.slice(0,3);
      }

      return -(this.activeSlide * (slideWidth + this.sliderGap));
    },
    activeReview() {
      return this.reviews[this.activeSlide];
    },
  },

  methods: {
    isSlideActive(slide) {
      if (this.slidesToShow === 3) {
        return this.activeSlide === (slide - 1) * (this.reviews.length / this.slidesToShow)
      } else {
        return this.activeSlide === slide - 1;
      }
    },
    handleSlideSelect(slide) {
      if (this.slidesToShow === 3) {
        this.activeSlide = (slide - 1) * (this.reviews.length / this.slidesToShow)
      } else {
        this.activeSlide = slide - 1;
      }
    },
    getSlideOpacity(i) {
      if (i >= this.activeSlide + this.slidesToShow || this.activeSlide > i) {
        return 0;
      } else {
        return 1;
      }
    },
    isMobile() {
      if (window.innerWidth > 700) {
        this.slidesToShow = 1;
      } else {
        this.slidesToShow = 1;
      }
      this.activeSlide = 0;
    },
    nextSlide() {
      // this.resetTimer();
      if (this.activeSlide + this.slidesToShow >= this.reviews.length) {
        this.activeSlide = 0;
      } else {
        this.activeSlide += this.slidesToShow;
      }
    },
    prevSlide() {
      // this.resetTimer();
      if (this.activeSlide - 1 < 0) {
        this.activeSlide = this.reviews.length - this.slidesToShow;
      } else {
        this.activeSlide -= this.slidesToShow;
      }
    },
    resetTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => this.nextSlide(), 10000);
    },
  },
}
</script>

<style scoped lang="sass">
@import '../../../sass/variables'

$width: 100%
$height: fit-content
$gap: 24px
$padding: 0
$radius: 0

.list__container
  display: flex
  position: relative
  flex-direction: column
  align-items: flex-start
  width: 100%
  min-height: 400px

  @media screen and (min-width: $lg)
    min-height: 320px

  .slides
    display: flex
    justify-content: center
    gap: 0px
    margin: 0 16px
    width: fit-content
    background: rgba(213, 213, 213, 1)
    border-radius: 40px

    .slide
      background: rgba(213, 213, 213, 1)
      min-width: 23px
      border-radius: 40px
      cursor: pointer
      transition: .3s ease
      height: 4px

      &.slide_active
        background: rgba(192, 60, 80, 1)

      @media screen and (min-width: $lg)
        min-width: 69px

  .controllers
    display: flex
    justify-content: flex-start
    align-items: center
    gap: 16px
    margin-top: 0
    width: 100%

    .img
      display: flex
      align-items: center
      justify-content: center
      min-width: 48px
      height: 48px

  .img
    cursor: pointer
    transition: .3s ease

    &:hover
      opacity: .8

    &.controller_disabled
      pointer-events: none
      opacity: .3

  .reviews__content
    display: flex
    flex-direction: column
    justify-content: space-between
    position: relative
    //overflow: hidden
    width: 100%
    flex-grow: 1

    .reviews__list
      display: flex
      position: absolute
      flex-direction: row
      gap: $gap
      left: 0
      top: 0
      transition: left .5s ease

  .review__stars
    display: flex
    justify-content: flex-start
    align-items: center
    gap: 0px

  .review
    display: flex
    flex-direction: column
    align-items: flex-start
    position: relative
    width: $width
    min-height: $height
    padding: $padding
    border-radius: $radius
    transition: .3s ease
    z-index: 1

    p
      position: relative
      font-size: 15px
      line-height: 22px
      font-weight: 400
      text-align: left
      //flex-grow: 1
      color: rgba(7, 24, 45, 1)
      margin-bottom: 0
      z-index: 1

      img
        position: absolute
        right: 0
        bottom: -24px
        z-index: -1

    .review__content
      display: flex
      flex-direction: column
      position: relative
      margin-top: 14px
      margin-bottom: 24px
      gap: 8px

    .review__author
      display: flex
      flex-direction: row
      justify-content: flex-start
      align-items: center
      width: 100%

      & > img
        //width: 60px
        margin-right: 16px

    .author__content
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      width: 100%

    .author__name
      font-size: 1rem
      line-height: 1.5rem
      font-weight: 600
      text-align: left
      color: rgba(7, 24, 45, 1)

    .review__date
      font-size: 1rem
      line-height: 1.5rem
      font-weight: 400
      text-align: left
      color: rgba(76, 96, 122, 1)
</style>
